import { Controller } from '@hotwired/stimulus';
import { postRequest, patchRequest } from '../../src/utils';

// Connects to data-controller="timetable--rearrange"
export default class extends Controller {
  static targets = ['saveBtn', 'disabledBtn', 'list', 'tab', 'container'];
  static values = {
    schoolId: Number,
    // whether assigning is in progress. Turns true in assignStart
    assigning: Boolean,
    // student and bandSpace id pair that is to be added to studentsToUpdate
    activeAssignment: Object,
    // the final array of student and band space id pairs to update
    assignments: Array,
    activeBandSpaceId: String,
    activeStudent: Object,
    activeStudentNameValue: String,
    activeStudentTdId: String,
  };

  connect() {
    // document.addEventListener('turbo:load', (event) => {
    //   // Code to execute when a new page is loaded via Turbo
    //   console.log('TURBO LOAD!!!!');
    //   let params = this.formParams(
    //     'search-school-assign_waiting_list_students'
    //   );
    //   console.log({ params });
    // });
    // document.addEventListener('turbo:stream', (event) => {
    //   // Code to execute when a new page is loaded via Turbo
    //   console.log('TURBO LOAD!!!!');
    //   let params = this.formParams(
    //     'search-school-assign_waiting_list_students'
    //   );
    //   console.log({ params });
    // });
  }

  // on click of waiting list student assign btn OR empty band space
  assign(event) {
    let { kind, id } = event.currentTarget.dataset;
    // if click on bandspace, store the band space that was clicked on in memory
    if (kind == 'bandSpace') this.activeBandSpaceIdValue = event.currentTarget.id;
    // if click on student, store the studnet name in memory (so that it can be inserted to the band space html later)
    if (kind == 'student') this.activeStudentValue = event.currentTarget.dataset;
    // store the id of the assign button td
    if (kind == 'student') this.activeStudentTdIdValue = event.currentTarget.id;
    // if the assignment process has just started go to assignStart
    // if now it is the second step of assigning process, go to assignConfirm
    // this allows to start the proces from clicking either Assign Button or Empty Band Space
    this.assigningValue ? this.assignConfirm(event, id, kind) : this.assignStart(event, id, kind);
  }

  async cancel(event) {
    let { currentTarget } = event;
    let { studentId, bandSpaceId, studentStatus } = currentTarget.dataset;
    // remove student band space pair from pairs to be updated
    this.cancelAssignment(studentId, bandSpaceId);
    try {
      await this.assignStudent({
        student: studentId,
        bandSpace: null,
        formerBandSpace: bandSpaceId,
      });
    } catch (error) {
      window.alert('Something went wrong, please try again later');
    }
  }

  // adds the first item (band space or student id) to the activeAssignment
  assignStart(event, id, kind) {
    // add ring to band space that was selected
    event.currentTarget.classList.add('focus:ring-2');
    this.assigningValue = true;

    // adds a kind and id received from assign to this.activeAssignmentValue
    this.updateActiveAssignment(kind, id);
  }

  // adds student and band space to assigned students
  async assignConfirm(event, id, kind) {
    let sameKind = Object.keys(this.activeAssignmentValue).includes(kind);
    // if clicked on same kind, reset & restart assign process
    if (sameKind) {
      // if yes initiates assignStart with the new id and kind
      this.resetToDefaults();
      this.assignStart(event, id, kind);
    } else {
      // if clicked on different kind, add id and kind to the activeAssignmentValue
      this.updateActiveAssignment(kind, id);
      if (this.wannaProceed()) {
        try {
          // await this.updateStudentStatus(this.activeStudentValue.id, 'assigning')
          await this.assignStudent(this.activeAssignmentValue);
        } catch (error) {
          window.alert('Something went wrong, please try again later');
        } finally {
          // this.addToAssignments();
          // this.addStudentHTML()
          this.resetToDefaults();
        }
      } else {
        this.resetToDefaults();
      }
    }
  }

  // remove student band space pair from assignments value
  cancelAssignment(studentId, bandSpaceId) {
    // filter pair out of assignments value
    let assignments = this.assignmentsValue;
    assignments = assignments.filter((assignment) => {
      return assignment.student !== studentId && assignment.bandSpace !== bandSpaceId;
    });
    // reassign assignments value
    this.assignmentsValue = assignments;
  }
  // add a new value (band space or student) to activeAssignment
  updateActiveAssignment(kind, id) {
    let activeAssignment = this.activeAssignmentValue;
    activeAssignment[kind] = id;
    this.activeAssignmentValue = activeAssignment;
  }

  // add an activeAssignment to assignments
  addToAssignments() {
    let assignments = this.assignmentsValue;
    assignments.push(this.activeAssignmentValue);
    this.assignmentsValue = assignments;
  }

  //  reset the values to their original state
  resetToDefaults() {
    this.activeAssignmentValue = {};
    this.assigningValue = false;
    this.activeBandSpaceIdValue = '';
  }

  async discard() {
    try {
      await this.batchDiscardAssignments();
    } catch (error) {
      window.alert('Something went wrong, please try again later');
    } finally {
      location.reload();
    }
  }

  async batchDiscardAssignments() {
    // if (!this.assignmentsValue) return
    try {
      await postRequest(`/admin/schools/${this.schoolIdValue}/batch_discard_assignments`);
    } catch (error) {
      throw error;
    } finally {
      location.reload();
    }
  }

  toggleView(e) {
    this.containerTarget.classList.toggle('2xl:grid');
  }

  toggleLists() {
    this.listTargets.forEach((target) => target.classList.toggle('hidden'));
    this.tabTargets.forEach((target) => target.classList.toggle('active-tab'));
    this.tabTargets.forEach((target) => target.classList.toggle('inactive-tab'));
  }

  async assignStudent(assignment) {
    // Update student with new band space, keep the filter params
    let data = {
      student: { band_space_id: assignment.bandSpace },
      turbo_stream: 'assign_students',
      band_space_id: assignment.formerBandSpace,
      // assigned_students_q: this.formParams('search-school-assigned_students'),
      // assign_waiting_list_students_q: this.formParams(
      //   'search-school-assign_waiting_list_students'
      // ),
      // legacy_params: {},
    };
    try {
      let resp = await patchRequest(`/admin/students/${assignment.student}`, data);
      let html = await resp.text();
      await Turbo.renderStreamMessage(html);
    } catch (error) {
      throw error;
    }
  }

  wannaProceed() {
    if (this.activeStudentValue.studentStatus != 'requested_transfer') return true;

    return confirm(
      `Are you sure you want to assign ${this.activeStudentValue.studentName} to this space? Once assigned another student may take their old space.`
    );
  }

  // formParams(dataTurboFrame) {
  //   // Check all filters fields and return an object with the params of the form
  //   let fields = {};
  //   // get the form by unique data-turbo-frame
  //   let form = document.querySelector(`[data-turbo-frame=${dataTurboFrame}]`);
  //   // // get all inputs of the form
  //   let inputs = form.querySelectorAll('input');
  //   // // iterate over inputs and add them to the fields object
  //   inputs.forEach((input) => {
  //     // if the input is a checkbox, add it to the fields object as an array
  //     if (input.name.endsWith('[]')) {
  //       fields[input.name.replace('[]', '')] = [...inputs]
  //         .filter((inp) => inp.name === input.name && inp.checked)
  //         .map((inp) => inp.value);
  //       // if the input is a regular field(text, number), add it to the fields object as a string
  //     } else {
  //       fields[input.name] = input.value;
  //     }
  //   });
  //   // convert the fields object to a params object that only includes relevant fields in a relevant format
  //   let params = Object.keys(fields).reduce((acc, key) => {
  //     if (key.startsWith('q[')) {
  //       let reg = /\[(.*?)\]/;
  //       let newKey = key.match(reg)[0].replace(/[\[\]]/g, '');
  //       acc[newKey] = fields[key];
  //     }
  //     return acc;
  //   }, {});
  //   return params;
  // }
}
